import React, { FC, useState, useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { selectToken } from "../../store/reducers/auth";
import { useGetUserQuery } from "../../store/services/user";
import { COOKIES_DOMAIN } from "../../constants";
import { ROUTES } from "../../routes";
import { useQueryParamAndCookie } from "../../hooks/useQueryParamAndCookie";
import { setLoading } from "../../store/reducers/ui";
import { ApplicationErrorBoundary } from "../errors";

export const PrivateOutlet: FC = () => {
  const [skip, setSkip] = useState(true);
  const token = useSelector(selectToken);
  const location = useLocation();
  const { state, pathname } = location;
  const dispatch = useDispatch();

  useQueryParamAndCookie("affid", undefined, {
    domain: COOKIES_DOMAIN,
  });

  const { data, isUninitialized, isLoading, isFetching } = useGetUserQuery(
    undefined,
    {
      skip,
    }
  );

  useEffect(() => {
    dispatch(setLoading(isLoading));

    return () => {
      dispatch(setLoading(false));
    };
  }, [dispatch, isLoading]);

  if (!token) {
    return <Navigate to={ROUTES.AUTH_LOGIN} state={{ from: { pathname } }} />;
  } else {
    skip && setSkip(false);
  }

  if (isUninitialized || isLoading || (!data?.phone && isFetching)) {
    return <></>;
  }

  if (state?.from) {
    return <Navigate to={state.from.pathname} />;
  }

  return data?.phone ? (
    <ApplicationErrorBoundary>
      <Outlet />
    </ApplicationErrorBoundary>
  ) : (
    <Navigate to={ROUTES.AUTH_LOGIN} state={{ from: { pathname } }} />
  );
};
